module.exports = __webpack_public_path__ + "img/cgsp2.10d5976e.jpg";